import React from 'react';
import 'url-search-params-polyfill';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/shared/utils/i18n';
import { store } from '@/shared/store';
import { withRouter } from '@/shared/HOC/with-router';
import { App } from '@/App';
import '@/shared/utils/set-lang';
import '@/shared/analytics';


const AppWithRouter = withRouter(App);
const container = document.getElementById('root');
const root = container && createRoot(container);


root && root.render(
    <BrowserRouter>
        <I18nextProvider i18n={ i18n }>
            <Provider store={ store }>
                <AppWithRouter />
            </Provider>
        </I18nextProvider>
    </BrowserRouter>
);
